module.exports = __webpack_public_path__ + "static/92c62a1b729742fdc3a59c302228f14e.svg";